import { IFramePlayerAbstractClass } from 'iframe/ts/player/abstract/IFramePlayerAbstractClass';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { IFrameCompanionMessage } from 'iframe_companion/ts/companion/messages/IFrameCompanionMessage';
export class IFramePlayerPostMessageInHandler extends IFramePlayerAbstractClass {
    constructor(iframePlayer) {
        super(iframePlayer, 'IFramePlayerPostMessageInHandler');
    }
    onPostMessage = (event) => {
        if (!this.utils.URL.originAllowed(event?.origin)) {
            return;
        }
        const mvpIframeUseCase = () => {
            if (!this.utils.Type.isEmpty(event?.data?.utag_data)) {
                this?.logger?.log('MVP:', 'onPostMessage:', event);
                this.utils.Delay.delay().then(() => {
                    this.dispatchIFramePlayerEvent({
                        type: IFramePlayerEvent.ON_MVP_PARENT_UTAG_DATA_RECEIVED,
                        data: {
                            utagData: event?.data?.utag_data
                        },
                        target: this,
                        targetName: this.name
                    });
                });
            }
        };
        const scriptedIframeUseCase = () => {
            this?.logger?.log('SCRIPTED:', 'onPostMessage:', event);
            const data = event?.data;
            switch (data?.message) {
                case IFrameCompanionMessage.ON_PARAMS_FROM_COMPANION:
                    this.dispatchIFramePlayerEvent({
                        type: IFramePlayerEvent.ON_COMPANION_PARAMS_RECEIVED,
                        data: {
                            utagData: data?.newTagParams?.utagData,
                            paramsVO: data?.newTagParams?.paramsVO
                        },
                        target: this,
                        targetName: this.name,
                        sendPostMessage: false
                    });
                    break;
            }
        };
        switch (this.scripted) {
            case false:
                mvpIframeUseCase();
                break;
            case true:
                scriptedIframeUseCase();
                break;
        }
    };
}
